/* global gdAlertify */
import React from "react";
import BuscarAuxiliar from "./BuscarAuxiliar";

function ModalBusquedaAuxiliar({ isOpen, onClose, onSelect, pacienteAuxiliares = [], excludeAuxiliarID = null }) {
    const handleSeleccionar = (row) => {
        onSelect(row);
        onClose();
    };

    if (!isOpen) return null;

    return (
        <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1" aria-labelledby="busquedaAuxiliarModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-xl">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="busquedaAuxiliarModalLabel">Búsqueda de Auxiliar</h5>
                        <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <div className="container-fluid">
                            {/* Buscador de Auxiliar */}
                            <BuscarAuxiliar
                                onSelect={handleSeleccionar}
                                titulo="Buscar Auxiliar por Nombre o RUT"
                            />

                            {/* Divider */}
                            <div className="d-flex align-items-center my-4">
                                <hr className="flex-grow-1" />
                                <span className="mx-3 text-muted">O selecciona de la lista</span>
                                <hr className="flex-grow-1" />
                            </div>

                            {/* Lista de Auxiliares del Paciente */}
                            <div className="card">
                                <div className="card-header bg-light">
                                    <h6 className="mb-0">
                                        <i className="fas fa-user-friends me-2"></i>
                                        Auxiliares que han trabajado con este paciente
                                        {pacienteAuxiliares.length > 0 && (
                                            <span className="badge bg-primary ms-2">
                                                {pacienteAuxiliares.length}
                                            </span>
                                        )}
                                    </h6>
                                </div>
                                <div className="card-body">
                                    {pacienteAuxiliares.length === 0 ? (
                                        <div className="alert alert-info mb-0">
                                            <i className="fas fa-info-circle me-2"></i>
                                            No hay auxiliares registrados para este paciente.
                                        </div>
                                    ) : (
                                        <div className="list-group">
                                            {pacienteAuxiliares.map((auxiliar) => {
                                                const isExcluded = auxiliar.id === excludeAuxiliarID;
                                                return (
                                                    <div
                                                        key={auxiliar.id}
                                                        className={`list-group-item ${isExcluded ? 'list-group-item-secondary' : 'list-group-item-action'}`}
                                                        style={{
                                                            cursor: isExcluded ? 'not-allowed' : 'pointer',
                                                            opacity: isExcluded ? 0.6 : 1
                                                        }}
                                                        onClick={() => !isExcluded && handleSeleccionar(auxiliar)}
                                                    >
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <div className={isExcluded ? 'text-decoration-line-through' : ''}>
                                                                <strong>
                                                                    {auxiliar.nombre} {auxiliar.apellidoPaterno} {auxiliar.apellidoMaterno}
                                                                </strong>
                                                                <br />
                                                                <small className="text-muted">
                                                                    <i className="fas fa-id-card me-1"></i>
                                                                    RUT: {auxiliar.rut}
                                                                    {auxiliar.celular && (
                                                                        <>
                                                                            <span className="mx-2">|</span>
                                                                            <i className="fas fa-phone me-1"></i>
                                                                            {auxiliar.celular}
                                                                        </>
                                                                    )}
                                                                    {auxiliar.des_categoria && (
                                                                        <>
                                                                            <span className="mx-2">|</span>
                                                                            <i className="fas fa-star me-1"></i>
                                                                            {auxiliar.des_categoria}
                                                                        </>
                                                                    )}
                                                                </small>
                                                            </div>
                                                            {isExcluded ? (
                                                                <span className="badge bg-warning text-dark">
                                                                    <i className="fas fa-ban me-1"></i>
                                                                    Auxiliar de la solicitud
                                                                </span>
                                                            ) : (
                                                                <button
                                                                    className="btn btn-sm btn-success"
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        handleSeleccionar(auxiliar);
                                                                    }}
                                                                >
                                                                    <i className="fas fa-check me-1"></i>
                                                                    Seleccionar
                                                                </button>
                                                            )}
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onClose}>Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ModalBusquedaAuxiliar;
